export const LATE_FEE_ALL_TAB_ID = 'ALL'
export const LATE_FEE_LATE_TAB_ID = 'LATE'
